import { useContext } from "react";
import { ModeContext, type ModeContextValue } from "@/context/modeTypes";

export function useMode(): ModeContextValue {
  const ctx = useContext(ModeContext);
  if (!ctx) throw new Error("useMode must be used within ModeProvider");
  return ctx;
}
